import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import Payment from '../Payment'
import States from 'Components/Elements/Forms/StatesModal/Country/SaudiarabiaStates.json'
import SaudiarabiaAddressData from 'Configs/Address/Saudiarabia/SaudiarabiaAddressData.json'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'
import ServicePointList from 'Configs/Address/Saudiarabia/ServicePointData.json'
import storeCheckout from '../StoreCheckout'
import { TrackingEvents } from 'Services/Tracker/TrackerConfigs'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import trackingEvents from 'Services/Tracker/TrackingEvents'
import storeAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'

class SaudiArabia {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip_code'
    }

    chainAddress = {
        isChainAddress: true,
        groupAddress: ['city_selection', 'district_selection']
    }

    uuid = ''
    selectedShippingPaymentOption = null
    addressListOptions = []
    prefixPhoneNumber = ''

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            phone: '',
            password: '',
            shipment_options: 'delivery'
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',
            shipment_options: 'delivery'
        },
        shop: {
            uuid: this.GetUuid(),
            city: '',
            // zip: '',
            email: '',
            shipment_options: 'delivery'
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        state: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        // city: '',
        // district: '',
        // zip: '',
        period: '',
        shipment_options: 'delivery'
    }

    ExcludedFieldsShippingIfCreateAccount = []

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        street_address: 'address',
        city_selection: "region",
        district_selection: "city",
        firstname: 'firstname_en',
        lastname: 'lastname_en',
        area: 'landmark',
        shipping_method_selection: 'service_point'
    }

    ArrangeCreateCheckoutForm = [
        'firstname',
        'lastname',
        'email',
        'password',
        'phone',
        'country',
        'city_selection',
        'district_selection',
        'address',
        'area',
        'shipping_method_selection'
    ]

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'purchase',
            link: '/checkout/payment',
            paramsRequire: true
        }
        // {
        //     caption: 'billing',
        //     link: '/checkout/payment',
        //     paramsRequire: true
        // },
        // {
        //     caption: 'purchase',
        //     link: '/checkout/review',
        //     paramsRequire: true
        // }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'delivery',
            title: 'home_delivery',
            dict_key: 'home_delivery',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'bank_wire',
                    dict_key: 'bank_transfer',
                    value: 'bankwire',
                    for_status: [],
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: '',
                },
                {
                    id: 2,
                    title: 'creditcard',
                    dict_key: 'myfatoorah',
                    value: 'creditcard',
                    for_status: [],
                    descripion: {
                        title: '',
                        dict_key: ''
                    },
                    icon: '',
                },
                // {
                //     id: 3,
                //     title: 'cash_on_delivery',
                //     dict_key: 'cash_on_delivery',
                //     value: 'cashOnDelivery',
                //     for_status: [],
                //     descripion: {
                //         title: '',
                //         dict_key: ''
                //     },
                //     icon: '',
                // }
            ]
        },
        // {
        //     id: 2,
        //     api_value: 'pickuppoint',
        //     title: 'pickup_saudiarabia_office',
        //     dict_key: 'pick_up_service_point',
        //     for_status: [],
        //     options: [
        //         {
        //             id: 1,
        //             title: 'bank_wire',
        //             dict_key: 'bank_transfer',
        //             value: 'bankwire',
        //             for_status: [],
        //             descripion: {
        //                 title: '',
        //                 dict_key: ''
        //             },
        //             icon: '',
        //         },
        //         {
        //             id: 1,
        //             title: 'creditcard',
        //             dict_key: 'myfatoorah',
        //             value: 'creditcard',
        //             for_status: [],
        //             descripion: {
        //                 title: '',
        //                 dict_key: ''
        //             },
        //             icon: '',
        //         },
        //     ]
        // }
        // ------------------------- if get pickup point comeback can remove comment index 2 ------------------------- //
    ]

    // PaymentGateway = 'hydra3ds'
    paymentMethod = 'creditCard'

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping',
            fromOrderCal: true
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: false,
            allowToUse: [],
            allowToEdit: false
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        },
        // shippingWithoutMethod: {
        //     display: true,
        //     displayStep: ['payment'],
        //     dict_key: 'shipping'
        // }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    ServicePointList() {
        let items = []
        ServicePointList.map(raw => {
            items.push({
                text: raw.address,
                value: raw.address,
                html: `<span>${raw.address}</span>`
            })
        })
        return items
    }

    StatesList() {
        const StatesList = this.GetAddressListOptions()
        const stationSelected = storeCheckout.GetCheckoutForms().find(item => item.key === 'city_selection')
        const stationSelectedValue = stationSelected.value
        let items = []
        
        if (stationSelectedValue === '') {
            StatesList.map(raw => {
                items.push({
                    text: raw["City Name"],
                    value: raw["City Name"],
                    html: `<span>${raw["City Name"]}</span>`
                })
            })  
        }

        
        const filteredStates = StatesList.filter(raw => raw["Station Name"] === stationSelectedValue)
        filteredStates.map(raw => {
            items.push({
                text: raw["City Name"],
                value: raw["City Name"],
                html: `<span>${raw["City Name"]}</span>`
            })
        })  
        return items
    }

    AddressOptionList(key = '', fn) {
        // key have city_selection === region, district_selection === city
        const addressData = this.GetAddressListOptions()

        //note: city_selection is region, district_selection is city
        let items = { region: [], city: [] }

        const uniqueRegion = [...new Set(addressData.map(item => 
            item[StoreTranslate.IsEnglish() ? 'region_name_english' : 'region_name_native']
        ))].sort()

        const region = uniqueRegion.map(item => {
            return {
                region_name: item,
            }
        })

        region.map(raw => {
            items = {
                ...items,
                region: [
                    ...items.region,
                    {
                        text: raw.region_name,
                        value: raw.region_name,
                        html: `<span>${raw.region_name}</span>`
                    }
                ]
            }
        })

        const regionValue = get(
            (fn.GetCheckoutForms() || []).find(item => item.key === 'city_selection'),
            'value'
        )

        if (regionValue) {
            const filteredCityByRegion = addressData.filter(raw =>
                 raw[StoreTranslate.IsEnglish() ? 'region_name_english' : 'region_name_native'] === regionValue
            )

            const sortedCities = filteredCityByRegion.map(raw => 
                raw[StoreTranslate.IsEnglish() ? 'city_name_english' : 'city_name_native']
            ).sort()

            sortedCities.forEach(city => {
                items = {
                    ...items,
                    city: [
                        ...items.city,
                        {
                            text: city,
                            value: city,
                            html: `<span>${city}</span>`
                        }
                    ]
                }
            })
        } else {
            items = {
                ...items,
                city: []
            }
        }

        return key === 'city_selection' ? items.region : items.city
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    GetPageConfig() {
        return this.pageConfig
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    SetSelectedShippingPaymentOption(value) {
        this.selectedShippingPaymentOption = value
    }

    GetSelectedShippingPaymentOption() {
        return this.selectedShippingPaymentOption
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    GetPaymentMethod() {
        return this.paymentMethod
    }

    SetPaymentMethod(value) {
        runInAction(() => {
            this.paymentMethod = value
        })
    }

    SetAddressListOptions(value) {
        runInAction(() => {
            this.addressListOptions = value
        })
    }

    GetAddressListOptions() {
        return this.addressListOptions
    }

    /**
     *
     * @param {*} uuiSubmitPaymentd
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */

    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, products, options) {
        try {
            const Pay = new Payment(uuid, detailPage)
            const responsePreparePayment = await Pay.PreparePaymentData()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }


            Pay.hydra.transactions = {
                items: [CreditCardEncrypted]
            }

            await Pay.PostToHydra()
            await Pay.UpdateToLog()

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.log(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async SubmitCashOnDeliveryPayment(uuid, detailPage, products) {
        try {
            const allowCreditEnable = storeAuth.IsAllowCredit()
            const data = {
                uuid: uuid,
                payment_options: 'cashondelivery',
                shipment_packs: JSON.stringify(storeCheckout.GetCart())
            }

            const responseFormat = await FormatAPIs.putHotFormatV2(data, storeCountry.Country3())
            if (responseFormat) {
                const Pay = new Payment(uuid, detailPage)
                const responsePreparePayment = await Pay.PreparePaymentData() // member-calls2/hydra-value

                if (!Pay.hydra.transactions) {
                    Pay.hydra.transactions = {}
                }
    
                const transaction = { ...responsePreparePayment.data?.data?.hydra?.transactions }

                Pay.hydra.transactions = transaction

                // ------------------------------------------------------------

                if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                    const productCredit = storeCredit.GetCreditData()
    
                    if (productCredit.creditType === 'cashCoupon') {
                        Pay.hydra.transactions.items.push({ ...storeCredit.cashCouponForm, amount: productCredit.creditUsed })
                    }
                    if (productCredit.creditType === 'arBalance') {
                        Pay.hydra.transactions.items.push({ ...storeCredit.arBalanceForm, amount: storeCheckout.GetFinalARBalance() })
                    }
                }
                
                // ------------------------------------------------------------
                await Pay.PostToHydra() //hydra create order

                Pay.SendEmailV4()
                
                await Pay.UpdateToLog()

                let baId = storeAuth.GetId() || undefined
                const responsePaymentDetail = await FeelGreatAPI.GetPaymentDetail(responsePreparePayment.data.data.payment_id, baId)
                runInAction(() => {
                    StorePaymentStep.PaymentDone = true
                })

                try {
                    trackingEvents.PurchaseEvent({
                        transaction_id: responsePreparePayment.data.data.payment_id,
                        value: Pay.ushop.total_price,
                        currency: 'SAR',
                        category: Pay.ushop.shipment_purchas_option,
                        items: products
                    })
                } catch (e) {
                    console.error('TrackingEvents.PurchaseEvent', e)
                }
    
                return {
                    success: true,
                    payment_id: responsePreparePayment.data.data.payment_id,
                    order_number: responsePaymentDetail.data.order_number
                }
            }

        } catch (error) {
            console.error(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async SubmitBankwirePayment(uuid, detailPage, products) {
        try {
            const Pay = new Payment(uuid, detailPage)
            const responsePreparePayment = await Pay.PreparePaymentData()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            
            const allowCreditEnable = storeAuth.IsAllowCredit()
            
            Pay.hydra.transactions = {
                items: [
                    {
                        amount: 'this.terms.total',
                        type: 'IOU',
                        method: 'BankWire',
                        billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                        billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                        billToAddress: {
                            country: storeCountry.Country2()
                        }
                    }
                ]
            }

            // ------------------------------------------------------------

            if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                const productCredit = storeCredit.GetCreditData()

                if (productCredit.creditType === 'cashCoupon') {
                    Pay.hydra.transactions.items.push({ ...storeCredit.cashCouponForm, amount: productCredit.creditUsed })
                }
                if (productCredit.creditType === 'arBalance') {
                    Pay.hydra.transactions.items.push({ ...storeCredit.arBalanceForm, amount: storeCheckout.GetFinalARBalance() })
                }
            }
            // ------------------------------------------------------------

            await Pay.PostToHydra()

            Pay.SendEmailV4()

            await Pay.UpdateToLog()

            const responsePaymentDetail = await PaymentAPIs.GetPaymentDetail(responsePreparePayment.data.data.payment_id)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            try {
                trackingEvents.PurchaseEvent({
                    transaction_id: responsePreparePayment.data.data.payment_id,
                    value: Pay.ushop.total_price,
                    currency: 'SAR',
                    category: Pay.ushop.shipment_purchas_option,
                    items: products
                })
            } catch (e) {
                console.error('TrackingEvents.PurchaseEvent', e)
            }
            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                order_number: responsePaymentDetail.data.order_number
            }
        } catch (error) {
            console.error(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false, error: error }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems, shippingMethod) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}
            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }

                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            if (!shippingMethod) {
                return {
                    success: false,
                    shippingMethodIsRequired: true
                }
            }

            delete forms.country

            const periodResponse = await FeelGreatAPI.GetPeriod('SA')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            forms.shipment_options = shippingMethod
            forms.country_calling_code = storeCheckout.dialCode.replace('+', '')

            if (shippingMethod === 'pickuppoint') {
                delete forms['address']
                delete forms['landmark']
            }

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/SAU/feelGreat/createAccount${ServerEnv.ENV === 'DEV' ? '?dev=1' : '?emailDelay=1h'
                }`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    SpecialAreasDeliveryFeeCondition(step) {
        let totalPrice = 0

        // const shippingMethod = storeCheckout.GetShippingMethod()
        // const city = storeCheckout.GetShippingForm().find(item => item.key === 'city_selection' && item.value)

        // // has shipfee for delivery
        // if (get(shippingMethod, 'api_value') === 'pickup' || !this.orderSummaryConfig.shippingWithoutMethod.displayStep.includes(step)) return totalPrice

        // const products = toJS(StoreProducts.GetProducts())
        // const onetimeItems = get(storeCheckout.GetCart(), 'onetime')
        // let totalOnetimePV = 0

        // if (!isEmpty(onetimeItems)) {
        //     const onetimeProducts = Object.keys(onetimeItems)
        //     onetimeProducts.forEach(item => {
        //         const productPV = get(products, [item, 'onetime', 'pv'], 0)
        //         const productQty = get(onetimeItems, item, 0)
        //         totalOnetimePV = totalOnetimePV + productPV * productQty
        //     })
        // }

        // console.log('city', city)

        // if (['amman'].includes(get(city, 'value', '').toLowerCase())) {
        //     totalPrice = 2.5
        // } else if (['zarqa'].includes(get(city, 'value', '').toLowerCase())) {
        //     totalPrice = 3
        // } else {
        //     totalPrice = 4
        // }

        // if (totalOnetimePV > 50) {
        //     totalPrice = 0
        // }

        return totalPrice
    }
    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        makeAutoObservable(this)
    }
}

export default SaudiArabia
